import { A, useNavigate } from '@solidjs/router'
import { userStore } from '/web/store'
import { isLoggedIn } from '/web/store/api'
import HeaderAccountMenu from './Header/HeaderAccountMenu'
import { Show } from 'solid-js'
import { subscribe } from '/web/store/socket'

const Header = (props: { showMenu?: boolean }) => {
  const nav = useNavigate()
  const user = userStore()

  subscribe(
    'profile-tokens-changed',
    { userId: 'string', tokens: 'number', hasClaimedInitialTokens: 'boolean?' },
    (body) => {
      if (user.profile) {
        userStore.setState({
          profile: {
            ...user.profile,
            totalAvailableTokens: body.tokens,
            hasClaimedInitialTokens:
              body.hasClaimedInitialTokens ?? user.profile.hasClaimedInitialTokens,
          },
        })
      }
    }
  )

  return (
    <div class="flex h-[58px] items-center justify-between font-clash md:h-[82px] ">
      <div class="flex flex-shrink-0 items-center gap-2">
        <Show when={props.showMenu ?? false}>
          <button class="block flex-shrink-0 lg:hidden" onClick={() => userStore.openSideMenu()}>
            <img src="/images/menu-btn.png" alt="" class="h-[30px] w-[30px]" />
          </button>
        </Show>
        <A href="/">
          <img
            class="mt-1  h-[30px]  md:h-[38px]"
            src={'/images/cosplayfans-logo.png'}
            alt="logo"
          />
        </A>
      </div>
      <div class="flex items-center justify-center gap-2 lg:gap-4">
        <button
          onClick={() => {
            if (!isLoggedIn()) {
              userStore.loginModal(true)
            } else {
              return nav('/generate-image/')
            }
          }}
          class="bg-opacity-7 text-shadow hidden h-7 flex-shrink-0 items-center justify-center rounded-md border border-white bg-[#0000001e] px-3 font-clash text-sm font-medium text-white shadow backdrop-blur lg:flex"
        >
          Generate Image
        </button>
        <button
          onClick={() => {
            if (!isLoggedIn()) {
              userStore.loginModal(true)
            } else {
              return nav('/chat/')
            }
          }}
          class="bg-opacity-7 text-shadow hidden h-7 flex-shrink-0 items-center justify-center rounded-md border border-white bg-[#0000001e] px-4 font-clash text-sm font-medium text-white shadow backdrop-blur lg:flex"
        >
          Live Chat
        </button>
        <button
          onClick={() => userStore.directoryModal(true)}
          class="bg-opacity-7 text-shadow hidden h-7 flex-shrink-0 items-center justify-center rounded-md border border-white bg-[#0000001e] px-3 font-clash text-sm font-medium text-white shadow backdrop-blur lg:flex"
        >
          Directory
        </button>
        <Show when={!isLoggedIn()}>
          <button
            onClick={() => {
              userStore.loginModal(true)
            }}
            class="hidden h-[30px] flex-shrink-0 items-center gap-2 rounded-md border bg-red-500 px-2 font-clash text-sm font-semibold text-white shadow md:flex lg:h-7"
          >
            <span>Tokens +</span>
          </button>
          <button
            onClick={() => userStore.loginModal(true)}
            class="text-shadow h-[30px] flex-shrink-0 rounded-md border border-white px-2 font-clash text-sm font-medium text-white shadow lg:block"
            style="background: linear-gradient(115deg, #9333ea, #2563eb)"
          >
            Join Free
          </button>
        </Show>
        <Show when={isLoggedIn()}>
          <button
            onClick={() => {
              userStore.buyTokensModal(true)
            }}
            class="bg-opacity-7 bg-blur text-shadow flex h-[30px] flex-shrink-0 items-center gap-2 rounded-md border bg-red-500 px-2 font-clash text-sm font-medium text-white shadow lg:h-7"
          >
            <img src="/images/tokens-star.png" class="h-5 w-5" />
            {user?.profile?.totalAvailableTokens || 0} Tokens
          </button>
          <div class="hidden h-[30px] md:block">
            <HeaderAccountMenu username={user?.profile?.handle} />
          </div>
        </Show>
      </div>
    </div>
  )
}

export default Header
